import { cva } from 'class-variance-authority';

const base = `inline-flex flex-[1_0_50%] cursor-pointer rounded-sm shadow-xs 
  lg:relative lg:flex-1 lg:items-center lg:justify-center lg:rounded-none 
  lg:border-t lg:border-b lg:border-color-grey lg:shadow-none 
  lg:hover:bg-color-grey-light lg:transition-colors lg:duration-200`;

const activeIndicator = `lg:rounded-b-none lg:after:content-[''] lg:after:absolute lg:after:inset-x-0 
  lg:after:bottom-0 lg:after:h-0.5 lg:after:rounded-tl lg:after:rounded-tr lg:after:bg-color-primary`;

export const responsiveNavigationMainItemVariants = cva(base, {
  variants: {
    open: {
      true: 'bg-color-grey-light lg:border-b-transparent',
      false: '',
    },
    active: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    // Show underline indicator only when NOT open but active
    { open: false, active: true, class: activeIndicator },
  ],
  defaultVariants: {
    open: false,
    active: false,
  },
});
